<template>
  <div class="d-flex w-100 pb-3 mt-5 grouptext-container">
    <div class="ml-2 d-flex flex-wrap w-100" v-if="isShowAll">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="mr-2 my-1 keyword-box px-3 py-1"
      >
        <div class="text-keyword">
          {{ item.message }}
        </div>
      </div>
      <div
        class="ml-1 my-auto text-main-color pointer"
        @click="$emit('setShowAllGroupText')"
        v-if="dataList.length > 6"
      >
        See less
      </div>
    </div>
    <div v-else class="ml-2 d-flex flex-wrap w-100">
      <div
        v-for="(item, index) in dataList.slice(0, 6)"
        :key="index"
        class="mr-2 my-1 keyword-box px-3 py-1"
      >
        <div class="text-keyword">
          {{ item.message }}
        </div>
      </div>
      <div
        class="ml-1 my-auto text-main-color pointer"
        @click="$emit('setShowAllGroupText')"
        v-if="dataList.length > 6"
      >
        See more... ({{ dataList.length }})
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      required: true,
      type: Array,
    },
    isShowAll: {
      required: true,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.keyword-box {
  background-color: #e2dff3;
  color: #707070;
  font-size: 12px;
  white-space: break-spaces;
  font-weight: 400 !important;
  border-radius: 25px;
  display: flex;
}
.w-15 {
  width: 10%;
}

.text-main-color {
  color: #40a9d1;
  text-decoration: underline;
}

.grouptext-container {
  border-bottom: 1px solid #bebebe;
  padding-bottom: 1rem;
}

.text-keyword {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin: auto;
}
@media (max-width: 767.98px) {
  .w-15 {
    width: 50%;
  }
}
</style>
